import HttpUtil from "../util/HttpUtil";

const hideDrawerType = "HIDE_DRAWER";
const openDrawerType = "OPEN_DRAWER";

export const hidePreScreenType = "HIDE_PRE_SCREEN";
const logoutType = "LOGOUT";

export const checkLoginType = "CHECK_LOGIN";
export const showGlobalLoaderType = "SHOW_GLOBAL_LOADER";
export const showSnackBarType = "SHOW_SNACK_BAR";
const hideSnackBarType = "HIDE_SNACK_BAR";
export const hideGlobalLoaderType = "HIDE_GLOBAL_LOADER";
export const fetchNotificationsType = "FETCH_NOTIFICATIONS";

const initialState = {
    showLoginButton: true,
    drawerOpen: false,
    searchComponent: null,
    user: null,
    globalLoading: false,
    showPreScreen: true,
    snackBarMessage: ""
};

export const actionCreators = {
    showGlobalLoader: () => ({ type: showGlobalLoaderType }),
    hideGlobalLoader: () => ({ type: hideGlobalLoaderType }),
    hideSnackBar: () => ({ type: hideSnackBarType }),
    checkLogin: () => async (dispatch, getState) => {
        var token = localStorage.getItem("accessToken");
        if (token) {
            HttpUtil.fetchGet("api/Login/CheckToken", { accessToken: token, refreshToken: localStorage.getItem("refreshToken") }, true,
                data => {
                    if (data.accessToken !== undefined) {
                        localStorage.setItem("accessToken", data.accessToken);
                        localStorage.setItem("refreshToken", data.refreshToken);
                        localStorage.setItem("expires", data.expires);
                    }

                    dispatch({
                        type: checkLoginType,
                        isLogin: data.errorCode === 200,
                        user: data.profile
                    });
                    dispatch({ type: hidePreScreenType });
                },
                err => {
                    dispatch({ type: checkLoginType, isLogin: false });
                    dispatch({ type: hidePreScreenType });
                }
            );
        } else if (typeof document !== "undefined") {
            dispatch({ type: checkLoginType, isLogin: false });
        }
    },
    logout: () => (dispatch, getState) => {
        localStorage.removeItem("accessToken");
        dispatch({ type: logoutType, isLogin: false });
    },
    hideDrawer: () => ({ type: hideDrawerType }),
    openDrawer: () => ({ type: openDrawerType })
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === showGlobalLoaderType) {
        return {
            ...state,
            globalLoading: true
        }
    }

    if (action.type === hideGlobalLoaderType) {
        return {
            ...state,
            globalLoading: false
        }
    }

    if (action.type === hidePreScreenType) {
        return {
            ...state,
            showPreScreen: false,
            globalLoading: false
        }
    }

    if (action.type === checkLoginType) {
        return {
            ...state,
            showLoginButton: action.isLogin,
            user: action.user
        }
    }

    if (action.type === logoutType) {
        return {
            ...state,
            drawerOpen: false,
            showLoginButton: false,
            user: null
        }
    }

    if (action.type === showSnackBarType) {
        return {
            ...state,
            snackBarMessage: action.message
        }
    }

    if (action.type === hideSnackBarType) {
        return {
            ...state,
            snackBarMessage: ""
        }
    }

    if (action.type === openDrawerType) {
        return {
            ...state,
            drawerOpen: true
        }
    }

    if (action.type === hideDrawerType) {
        return {
            ...state,
            drawerOpen: false
        }
    }
    return state;
};
